import { buildSearchStatus } from '@coveo/headless';

export class RsHTMLElement extends HTMLElement {
    bindings;
    hideOnNoResults = true;
    initialized = false;
    searchInterface;
    shadow;

    async connectedCallback() {
        if (this.initialized) {
            return;
        }
        
        this.initialized = true;

        this.shadow = this.attachShadow({ mode: 'open' });
        
        await this.#initializeBindings()
            .catch((err) => {
                console.info(`Could not initialize bindings: ${err}`);
            });

        const searchStatus = buildSearchStatus(this.bindings.engine);
        searchStatus.subscribe(() => {
            if (this.hideOnNoResults) {
                this.classList.toggle('display-none', !searchStatus.state.hasResults);
            }
        });

        try {
            typeof this.styles === 'function' && this.addStyles(await this.styles());
            typeof this.connected === 'function' && await this.connected();
            typeof this.render === 'function' && await this.render();
            typeof this.mounted === 'function' && await this.mounted();
        } catch (error) {
            console.error(error);
        }
    }

    get i18n() {
        return this.bindings.i18n;
    }

    addStyles(styles, targetNode = this.shadow) {
        if (!styles) {
            return;
        }

        const sheet = new CSSStyleSheet();
        sheet.replaceSync(styles);

        targetNode.adoptedStyleSheets.push(sheet);
    }
    
    /*
        .closest does not go outside of the shadow dom, but this one does
    */
    closestElement(selector, element = this) {
        if (!element) {
            return null;
        }

        const closest = element.closest(selector);

        if (closest) {
            return closest;
        }

        const host = element.getRootNode().host

        return host ? this.closestElement(selector, host) : null;
    }

    async #initializeBindings() {
        await customElements.whenDefined('atomic-search-interface');

        this.searchInterface = this.closestElement('atomic-search-interface');

        return new Promise((resolve, reject) => {
            if (!this.searchInterface) {
                return reject('atomic-search-interface');
            }

            const event = new CustomEvent('atomic/initializeComponent', {
                detail: (bindings) => {
                    this.bindings = bindings;
                    resolve();
                }
            });

            this.searchInterface.dispatchEvent(event);
        });
    }
};